var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "row m-0 list-heading mt-3 list-manipulations",
        attrs: { "data-v-step": "campaignsView.view.main" }
      },
      [
        _c("div", { staticClass: "col m-0 p-0 centered" }, [
          _c("div", { staticClass: "date-tabs-container" }, [
            _c(
              "div",
              { staticClass: "header-date-tabs" },
              [
                _vm._t("grid-date-prefix"),
                _vm._v(" "),
                _vm.showRangePicker
                  ? _c("input-date-range", {
                      staticClass: "dr-input",
                      attrs: {
                        small: "",
                        slim: "",
                        transparent: "",
                        inputName: "dateRange",
                        inputValue: _vm.getActiveDate,
                        dateRangePickerPresets: _vm.dateRangePickerPresets
                      },
                      on: { fieldUpdate: _vm.changeDate }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("extraFilters")
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "list-manipulation-action-container",
              attrs: { "data-v-step": "campaignsView.view.calendar" }
            },
            [
              _c(
                "div",
                { staticClass: "mr-3" },
                [
                  _c("input-button", {
                    attrs: {
                      variant: "plainText",
                      btnStyle: "link-style",
                      inputPlaceholder: _vm.$t("Button.week"),
                      active: _vm.getDisplayStyle === "agendaWeek"
                    },
                    on: {
                      click: function($event) {
                        return _vm.setDisplayStyle("agendaWeek")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input-button", {
                    attrs: {
                      variant: "plainText",
                      btnStyle: "link-style",
                      inputPlaceholder: _vm.$t("Button.month"),
                      active: _vm.getDisplayStyle === "month"
                    },
                    on: {
                      click: function($event) {
                        return _vm.setDisplayStyle("month")
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-3 space-top grid-manipulators" },
                [
                  _c("q-icon", {
                    staticClass: "c-pointer",
                    attrs: {
                      active: _vm.getDisplayStyle === "list",
                      allowSelfUpdate: false,
                      width: "20px",
                      height: "20px",
                      pack: "leftMenu",
                      name: "listGrey",
                      altPack: "leftMenu",
                      altName: "listGreen"
                    },
                    on: {
                      click: function($event) {
                        return _vm.setDisplayStyle("list")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("q-icon", {
                    staticClass: "c-pointer",
                    staticStyle: { "margin-left": "13px" },
                    attrs: {
                      active: _vm.getDisplayStyle === "grid",
                      allowSelfUpdate: false,
                      width: "20px",
                      height: "20px",
                      pack: "leftMenu",
                      name: "gridGrey",
                      altPack: "leftMenu",
                      altName: "gridGreen"
                    },
                    on: {
                      click: function($event) {
                        return _vm.setDisplayStyle("grid")
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "spacer-ceditor d-none d-md-block" }),
    _vm._v(" "),
    _c("div", { staticClass: "spacer-ceditor-smaller d-block d-md-none" }),
    _vm._v(" "),
    _c("div", { staticClass: "row selected-posts pt-0 ml-0 mr-0" }, [
      _c(
        "div",
        { staticClass: "w-100" },
        [
          _c("mpe-grid", {
            ref: "mpeGrid",
            attrs: {
              validRange: _vm.getValidRange,
              campaignPreviewItems: _vm.campaignPreviewItems,
              useCalendarNavigation: _vm.useCalendarNavigation,
              listStyle: _vm.getDisplayStyle,
              listItems: _vm.listItems,
              variant: _vm.variant,
              removing: _vm.removing,
              viewedMonth: _vm.getViewedMonth
            },
            on: {
              editMpe: _vm.editMpe,
              removeMpe: _vm.removeMpe,
              setSchedule: _vm.setSchedule,
              duplicate: _vm.duplicate,
              changeDate: _vm.changeDate
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-045e2316", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-045e2316","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/display/CampaignGrid.vue
// module id = null
// module chunks = 